import React, { useMemo } from 'react';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { SelectWidgetWrapper } from '../common/select-widget/SelectWidgetWrapper';
import { getWidgetProps } from '../common/util/getWidgetProps';
import { IMultiSelectWidget, MultiSelectKind } from './IMultiSelectWidget';
import { MultiSelectCheckboxComponent } from './components/MultiSelectCheckboxComponent';
import { MultiSelectSelectComponent } from './components/MultiSelectSelectComponent';
import { useMultiSelectWidgetOptions } from './components/hooks/useMultiSelectWidgetOptions';
import { multiSelectOptionsObjectName } from './getMultiSelectOptionsObjectName';

export interface IMultiSelectWidgetComponentProps
  extends IWidgetComponentProps<IMultiSelectWidget> {}

// TODO
export function MultiSelectWidgetComponent(
  props: IMultiSelectWidgetComponentProps,
) {
  const { widget } = props;
  const widgetOptions = getWidgetProps(props);

  const { options, componentOptions } = useMultiSelectWidgetOptions({
    widget,
    name: widgetOptions.name,
    preview: widgetOptions.preview,
  });

  const fieldObjectName = multiSelectOptionsObjectName(widgetOptions.name);

  // Ci servono entrambi perché:
  // 1. `fieldItemName` è il nome dell'oggetto, quindi ci serve per `useInputController`
  //    (vedi inputSchema)
  // 2. `widgetOptions.name` è il nome del campo, quindi ci serve per mostrare
  //     gli errori (le regole di validazione sono sempre sul campo, non sull'oggetto
  //     delle opzioni)
  //
  // Come premessa, consideriamo che abbiamo sempre due valori, uno esplicito
  // (il campo) e uno implicito (l'oggetto delle opzioni). Questo ci serve
  // per poter inserire regole condizionali sulla _singola opzione_ selezionata
  // (Reference a singole opzioni, ad esempio)
  //
  // E' importante che il nome dell'oggetto sia _il primo_ perché è quello che
  // viene usato in `useInputController` per gestire il campo.
  const formItemNames = useMemo(
    () => [fieldObjectName, widgetOptions.name],
    [fieldObjectName, widgetOptions.name],
  );

  return (
    <SelectWidgetWrapper
      {...props}
      name={widgetOptions.name}
      formItemName={formItemNames}
    >
      {widget.kind === MultiSelectKind.Checkbox ? (
        <MultiSelectCheckboxComponent
          {...props}
          options={options}
          componentOptions={componentOptions}
        />
      ) : (
        <MultiSelectSelectComponent
          {...props}
          options={options}
          componentOptions={componentOptions}
        />
      )}
    </SelectWidgetWrapper>
  );
}
